import { Component, OnInit, ViewChild } from '@angular/core';
import { CalendarTypeEnum } from '../../shared/calendar-type.enum';
import { CalendarFormSubmission } from '../../shared/calendar-form-submission.model';
import { EventSubmissionService } from '../../shared/event-submission.service';
import { TranslationService } from 'src/app/shared';
import { NotificationService } from 'src/app/shared';
import { Error } from 'src/app/shared/model/error.model';
import { Select } from 'primeng/select';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'wl-submission-form-settings',
  templateUrl: './submission-form-settings.component.html',
  styleUrls: ['./submission-form-settings.component.less'],
    standalone: false
})
export class SubmissionFormSettingsComponent implements OnInit {
  @ViewChild('calendarType') calendarType: Select;
  formData: CalendarFormSubmission = new CalendarFormSubmission();
  initialFormData: CalendarFormSubmission = new CalendarFormSubmission();
  isSaving: boolean = false;
  calendarTypeOptions: SelectItem[] = [];

  constructor(
    private _eventSubmissionService: EventSubmissionService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    Object.keys(CalendarTypeEnum).forEach((key) => {
      if (!isNaN(Number(key))) {
        this.calendarTypeOptions.push({ label: CalendarTypeEnum[key], value: parseInt(key) });
      }
    });
    this._eventSubmissionService.getSubmissionFormSettings().then((data) => {
      if (data != null) {
        this.formData = data;
        this.initialFormData = JSON.parse(JSON.stringify(data));
      }
    });
  }

  save(): void {
    this.isSaving = true;
    this._eventSubmissionService
      .postSubmissionFormSettings(this.formData)
      .then(() => {
        this._notificationService.translateSuccess(
          this._translationService.getInstant('events.submissions.submission-form-settings.save-settings-success')
        );
      })
      .catch((error: Error) => {
        this._notificationService.translateError(error.Message);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
  cancel(): void {
    this.formData = this.initialFormData;
  }
}
